import { Map, OrderedMap, fromJS } from 'immutable';
import isEmpty from 'lodash/isEmpty';

import GoalsConstants from 'Shared/constants/Goals.constants';
import CommentsConstants from 'Shared/constants/Comments.constants';
import ReviewsConstants from 'Shared/constants/Reviews.constants';

const initialState = Map({
  [CommentsConstants.State.COMMENTS_BY_SLUG]: OrderedMap(),
});

export const CommentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReviewsConstants.Actions.FETCH_SINGLE_REVIEW_SUCCESS:
    case GoalsConstants.Actions.FETCH_SINGLE_GOAL_SUCCESS:
    case CommentsConstants.Actions.CREATE_COMMENT_SUCCESS:
    case CommentsConstants.Actions.UPDATE_COMMENT_SUCCESS:
      // is there is no data, json-api-normalizr will convert payload to
      // an empty object, we need to ensure it's not empty before trying to iterate over items
      if (isEmpty(action.payload)) {
        return state;
      }
      return state.updateIn([CommentsConstants.State.COMMENTS_BY_SLUG], (existing = OrderedMap()) =>
        existing.mergeDeep(
          Object.values(action.payload.comment).map(item => [item.attributes.uuid, Map(fromJS(item.attributes))])
        )
      );
    case CommentsConstants.Actions.DELETE_COMMENT_SUCCESS:
      return state.deleteIn([CommentsConstants.State.COMMENTS_BY_SLUG, action.payload]);
    default:
      return state;
  }
};
